import { Button, Checkbox } from "antd";
import styled from "styled-components";
import { COLORS, WEIGHT } from "../../../../layout/theme";

export const PageWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 22px;
	padding: 10px 0 30px 0;
`;

export const PageTitle = styled.h1`
	margin: 0;
	font-size: 26px;
	font-weight: 700;
	line-height: 1.1;
	color: #111827;
`;

export const SectionCard = styled.div`
	background: ${COLORS.White};
	border-radius: 16px;
	padding: 22px 20px;
	box-shadow: 0 4px 16px rgba(15, 23, 42, 0.08);
	border: 1px solid #eceff3;
`;

export const SectionHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	margin-bottom: 18px;
`;

export const SectionTitle = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	font-size: 16px;
	font-weight: 800;
	color: #4f46e5;
`;

export const SectionHeaderAction = styled.button`
	background: transparent;
	border: none;
	padding: 0;
	cursor: pointer;
	font-size: 14px;
	font-weight: 700;
	color: #4f46e5;
`;

export const FormGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(12, 1fr);
	gap: 14px 14px;

	@media only screen and (max-width: 900px) {
		grid-template-columns: 1fr;
	}
`;

export const GridCol4 = styled.div`
	grid-column: span 4;

	@media only screen and (max-width: 900px) {
		grid-column: span 1;
	}
`;

export const GridCol6 = styled.div`
	grid-column: span 6;

	@media only screen and (max-width: 900px) {
		grid-column: span 1;
	}
`;

export const GridCol12 = styled.div`
	grid-column: span 12;

	@media only screen and (max-width: 900px) {
		grid-column: span 1;
	}
`;

export const InnerForm = styled.div`
	display: flex;
	flex-direction: column;
	gap: 22px;
`;

export const ClientData = styled.div`
	display: flex;
	flex-direction: column;
	gap: 22px;
`;

export const PublishSettings = styled.div`
	background-color: ${COLORS.White};
	padding: 2rem;
	border-radius: 10px;
	max-height: 300px;
`;

export const AfipCuitInfo = styled.div`
	display: flex;
	flex-direction: column;
	gap: 14px;
`;

export const DistributorImage = styled.img`
	width: 40px;
	height: 40px;
	object-fit: contain;
`;

export const PreviewImage = styled.img`
	width: 120px;
	height: 120px;
	object-fit: contain;
	border-radius: 14px;
	border: 1px solid #e5e7eb;
	background: #f9fafb;
	padding: 8px;
`;

export const AntdCheckbox = styled(Checkbox)``;

export const BlockedData = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;

	.ant-input,
	.ant-input-affix-wrapper,
	.ant-select-selector,
	.ant-input-number,
	.ant-picker,
	.ant-input-group-addon {
		background: #f3f4f6 !important;
		color: #6b7280 !important;
		border-color: #e5e7eb !important;
		box-shadow: none !important;
		border-radius: 10px;
	}

	.ant-input[disabled],
	.ant-select-disabled .ant-select-selector,
	.ant-picker-disabled {
		color: #6b7280 !important;
	}
`;

export const RightContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`;

export const AntdButton = styled(Button)`
	height: 45px;
	border-radius: 12px;
	border: none;
	background: linear-gradient(90deg, #3b82f6 0%, #2563eb 100%);
	color: ${COLORS.White};
	font-weight: ${WEIGHT.Bold};
	box-shadow: 0 8px 18px rgba(37, 99, 235, 0.18);

	${(props) => props.height && `height: ${props.height}px;`}
	${(props) => props.width && `width: ${props.width}px;`}
	${(props) => props.fontSize && `font-size: ${props.fontSize}px;`}

	&:hover,
	&:focus,
	&:active {
		background: linear-gradient(90deg, #2563eb 0%, #1d4ed8 100%) !important;
		color: ${COLORS.White} !important;
		border: none !important;
	}

	span {
		${(props) => props.fontSize && `font-size: ${props.fontSize}px;`}
	}
`;

export const PrimaryActionButton = styled(Button)`
	width: 100%;
	height: 45px;
	border-radius: 12px;
	border: none;
	background: linear-gradient(90deg, #4f46e5 0%, #4338ca 100%);
	color: white;
	font-size: 16px;
	font-weight: 800;
	box-shadow: 0 8px 18px rgba(79, 70, 229, 0.22);

	&:hover,
	&:focus,
	&:active {
		background: linear-gradient(90deg, #4338ca 0%, #3730a3 100%) !important;
		color: white !important;
		border: none !important;
	}
`;

export const GhostDangerButton = styled(Button)`
	width: 100%;
	height: 44px;
	border: none;
	background: transparent;
	color: #dc2626;
	font-size: 15px;
	font-weight: 700;
	box-shadow: none;

	&:hover,
	&:focus,
	&:active {
		background: transparent !important;
		color: #b91c1c !important;
		border: none !important;
	}
`;

export const StatusSelectWrap = styled.div`
	.ant-select {
		width: 100%;
	}

	.ant-select-selector {
		height: 42px !important;
		border-radius: 10px !important;
		border: 1px solid #d1d5db !important;
		display: flex;
		align-items: center;
		padding: 0 12px !important;
	}
`;

export const VerificationBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

export const VerificationText = styled.div`
	font-size: 15px;
	color: #4b5563;
`;

export const VerificationData = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	padding: 8px 0 0 0;
`;

export const VerificationRow = styled.div`
	display: flex;
	justify-content: space-between;
	gap: 20px;
	align-items: flex-start;
	border-bottom: 1px solid #f1f5f9;
	padding-bottom: 8px;

	&:last-child {
		border-bottom: none;
		padding-bottom: 0;
	}
`;

export const VerificationLabel = styled.div`
	font-size: 14px;
	font-weight: 700;
	color: #334155;
`;

export const VerificationValue = styled.div`
	font-size: 14px;
	color: #111827;
	text-align: right;
	max-width: 60%;
`;

export const PurpleListCard = styled.div`
	background: ${COLORS.White};
	border-radius: 16px;
	overflow: hidden;
	box-shadow: 0 4px 16px rgba(15, 23, 42, 0.08);
	border: 1px solid #eceff3;
`;

export const PurpleListHeader = styled.div`
	background: linear-gradient(90deg, #4f46e5 0%, #4338ca 100%);
	color: white;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 14px 18px;
	font-size: 16px;
	font-weight: 800;
`;

export const PurpleListBody = styled.div`
	padding: 0px 16px;
`;

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

export const Section = styled.div`
	display: flex;
	gap: 10px;
	justify-content: space-between;
`;
